
  import { defineComponent, h } from 'vue';
  import './heading.scss';

  /**
   * A HTML heading is a title or a subtitle which you want to display within your content
   * 
   * @example
   * <code>import TpxHeading from '@manifesto-tech/tpximpact-design-system/components/atoms/type/heading.vue'</code>
   */
  export default defineComponent({
    name: 'TpxHeading',
    
    props: {
      /**
       * Content of the heading element
       */
      heading: {
        type: String,
        required: true,
      },

      /**
       * Specify if the header should be blue?
       * This helps to break up larger articles with attractive primary headings
       */
      isBlue: {
        type: Boolean,
      },

      /**
       * The <code>h1</code> to <code>h6</code> elements represent six levels of section headings
       */
      level: {
        default: 1,
        type: Number,
        required: true,
        validator: (value: number) => {
          return value > 0 && value < 7; 
        },
      }
    },

    render() {
      return h(
        `h${this.level}`,
        {
          class: {
            'text--blue': this.isBlue,
          },
        },
        this.heading,
      )
    },
  });
